/* eslint-disable react/prop-types */
/* eslint-disable react/no-array-index-key */
import React, { useMemo, useCallback } from 'react';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import { QUESTION_VALUE_TYPE } from '../../../../constants/common';
import AnswerItem from './AnswerItem';

const AnswerList = ({
  sample,
  answers,
  onAnswerChange,
  onHiddeChange,
  onAnswerIdOrderChange,
  onDirty,
  hiddenAnswers,
  answerIdOrders,
}) => {
  // Derived during render rather than mirrored into state. A useEffect copy
  // lags one render behind the prop, so every keystroke re-rendered the input
  // with the previous string; React wrote that stale value back into the DOM,
  // which collapses the caret to the end of the text.
  const answerList = useMemo(() => {
    const answerMaps = {};
    (answers || []).forEach((answer) => {
      answerMaps[answer.id] = answer.value;
    });
    return answerMaps;
  }, [answers]);

  const handleToggleHidden = (answer) => {
    const hiddenList = [...hiddenAnswers];
    const hiddenItemIndex = hiddenList.indexOf(answer.id);
    if (hiddenItemIndex >= 0) {
      hiddenList.splice(hiddenItemIndex, 1);
    } else {
      hiddenList.push(answer.id);
    }
    onHiddeChange(hiddenList);
    onAnswerIdOrderChange(answerIdOrders);
    onDirty();
  };

  const moveCard = useCallback(
    (result) => {
      if (!result.destination) {
        return;
      }
      const list = [...answerIdOrders];
      const [removedItem] = list.splice(result.source.index, 1);
      list.splice(result.destination.index, 0, removedItem);
      onAnswerIdOrderChange(list);
      onHiddeChange(hiddenAnswers);
      onDirty();
    },
    [answerIdOrders, onHiddeChange, hiddenAnswers, onAnswerIdOrderChange, onDirty]
  );

  return (
    <>
      {sample?.Data.valueType !== QUESTION_VALUE_TYPE.MULTIPLE && answers.length > 0 && (
        <div>
          <h4>Answers</h4>
          <DragDropContext onDragEnd={moveCard}>
            <Droppable droppableId="droppable">
              {(provided) => (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  {answerIdOrders.map((id, index) => {
                    const hiddenAnswer = hiddenAnswers.indexOf(id) >= 0;
                    return (
                      <Draggable
                        key={index}
                        draggableId={`draggable-report-item-${index}`}
                        index={index}
                      >
                        {(draggableProvided) => (
                          <AnswerItem
                            draggableProvided={draggableProvided}
                            key={index}
                            answer={{ id, value: answerList[id] }}
                            index={index}
                            hiddenAnswer={hiddenAnswer}
                            onAnswerChange={onAnswerChange}
                            handleToggleHidden={handleToggleHidden}
                            onDirty={onDirty}
                          />
                        )}
                      </Draggable>
                    );
                  })}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
      )}
    </>
  );
};

export default AnswerList;
